module.exports = __webpack_public_path__ + "static/media/31.cba4e359.mp3";